import { useState } from 'react';
import type { Contact } from '../../../types/contact';

export function useContactSingleSelection() {
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null);

  const handleSelectContact = (contact: Contact) => {
    setSelectedContact(contact);
  };

  return {
    data: {
      selectedContact,
    },
    actions: {
      handleSelectContact,
    },
  };
}
